/**
 * Marketing-specific analytics wrapper.
 * Re-exports everything from the shared Analytics library, but overrides
 * `sendAnalytics` to automatically inject the `audience` field from
 * sessionStorage when an audience token is active.
 *
 * This keeps browser-specific enrichment out of the shared library.
 * Vite alias in vite.config.ts redirects `@playcastdotio/Analytics` here.
 */

// Re-export all types and non-sendAnalytics exports
export * from '../../../libs/Analytics/src/index';

// Import the real sendAnalytics to wrap it
import { sendAnalytics as _sendAnalytics } from '../../../libs/Analytics/src/index';
import type { PlaycastAnalyticsOptions } from '../../../libs/Analytics/src/types';
import { getStoredAudience } from './app/constants/audienceSwapMap';

type AnalyticsEvent = Parameters<typeof _sendAnalytics>[0];

export const sendAnalytics = async (
  event: AnalyticsEvent,
  options?: PlaycastAnalyticsOptions,
): Promise<string> => {
  let enrichedEvent = event;

  try {
    const audience = getStoredAudience();
    if (audience && !('audience' in event)) {
      enrichedEvent = { ...event, audience } as AnalyticsEvent;
    }
  } catch {
    // storage unavailable
  }

  return _sendAnalytics(enrichedEvent, options);
};
